import styles from './MobileDisclosure.module.scss';
import { OverlayContent } from '../';
import { usePreventScroll } from '../../../../hooks';
import React, { useState } from 'react';
import {
  Disclosure,
  DisclosureContent,
  useDisclosureStore,
} from '@ariakit/react';
import classNames from 'classnames';
import {
  Button,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const MobileDisclosure = ({
  linkList,
  setOverlayVisibility,
  store,
  formSuccess,
  pageLink,
}) => {
  const [open, setOpen] = useState(false);
  const disclosure = useDisclosureStore({ open, setOpen });
  usePreventScroll(open);

  return (
    <div
      className={classNames(styles.mobileCard, {
        [styles.extended]: disclosure,
      })}
    >
      <Disclosure
        as="div"
        className={classNames(styles.disclosure, {
          [styles.collapsed]: !open,
        })}
        store={disclosure}
      >
        <Heading as="h1" noSpacing size="h6" theme="neutral">
          Ihre Auswahl ({linkList?.length})
        </Heading>
        <Button
          aria-label={`Produktberater ${open ? 'verstecken' : 'anzeigen'}`}
          className={classNames(styles.disclosureButton, {
            [styles.visible]: open,
          })}
          shape="bubble"
          size="small"
          theme="ghost"
        >
          <FontAwesomeProIcon
            icon="chevron-up"
            role="presentation"
            type="solid"
          />
        </Button>
      </Disclosure>
      <DisclosureContent
        className={classNames(styles.content, {
          [styles.extended]: open,
        })}
        store={disclosure}
      >
        <OverlayContent
          formSuccess={formSuccess}
          linkList={linkList}
          mobileDisclosure={disclosure}
          pageLink={pageLink}
          setOverlayVisibility={setOverlayVisibility}
          store={store}
        />
      </DisclosureContent>
    </div>
  );
};

MobileDisclosure.propTypes = {
  formSuccess: PropTypes.bool,
  linkList: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
    }),
  ).isRequired,
  pageLink: PropTypes.string,
  setOverlayVisibility: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
};

export { MobileDisclosure };
